import React from 'react';

import InfoRow from '../infoTable/InfoRow';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { LogbookEntry } from 'shared/sharedTypes/logbook/LogbookEntryModels';
import { useCurrentLogbook } from 'ff/debrief/hooks';

const AssociationList = () => {
    const { logbookEntries, isLogbookAssociated } = useCurrentLogbook();
    const associatedEntries = logbookEntries.filter(entry =>
        isLogbookAssociated(entry.objectId)
    );

    const getEntryUrl = (entry: LogbookEntry): string =>
        entry.provisional === 1
            ? `/logbook#/drafts?entryId=${entry.objectId}`
            : `/logbook#/entries?entryId=${entry.objectId}`;

    return (
        <>
            {associatedEntries.map(entry => (
                <InfoRow
                    key={entry.objectId}
                    value={''}
                    label={`${entry.departureAirport} to ${entry.destinationAirport}`}
                    border
                >
                    <ListItem key={entry.objectId} sx={{ padding: '0' }}>
                        <ListItemButton
                            target="_blank"
                            component={'a'}
                            href={getEntryUrl(entry)}
                            sx={{
                                padding: '0',
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Stack
                                flexDirection="row"
                                gap="6px"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Typography fontWeight="bold">
                                    {entry.flightDate}
                                </Typography>
                                <ArrowForwardIosIcon fontSize="small" />
                            </Stack>
                        </ListItemButton>
                    </ListItem>
                </InfoRow>
            ))}
        </>
    );
};

export default AssociationList;
